import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "driverStatus",
    standalone: false
})
export class DriverStatusPipe implements PipeTransform {
  transform(status: string): string {
    switch (status.toLowerCase()) {
      case "active":
        return "assets/image/Active_icon_dp.svg";
      case "offline":
        return "assets/image/Ofline_icon_dp.svg";
      case "inactive":
      default:
        return "assets/image/inactive_icon_dp.svg";
    }
  }
}
